function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import * as React from 'react';
function useMergedRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return React.useCallback(function (element) {
    for (var i = 0; i < refs.length; i++) {
      var ref = refs[i];
      if (typeof ref === 'function') ref(element);else if (ref && _typeof(ref) === 'object') ref.current = element;
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  refs);
}
export default useMergedRef;